import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Check, MoreHorizontal } from 'lucide-react'

import { type Metric, metricLabels, metricPhrase, metricValue } from './exploration'

import styles from './MetricExplorer.module.scss'

import type { AttributionFilters, AttributionSummary } from '@/api/attributionObservability'

export const primaryMetrics: Metric[] = [
  'labels_by_words',
  'fully_named',
  'summary_speaker_chips_named',
  'ax_capture',
  'meetings',
]
export const overflowMetrics: Metric[] = ['labels', 'ax']

export default function MetricChoices({
  metric,
  summary,
  filters,
  chipValue,
  chipSourceLabel,
  onSelect,
}: {
  metric: Metric
  summary?: AttributionSummary
  filters: AttributionFilters
  chipValue: string
  chipSourceLabel: string
  onSelect: (metric: Metric) => void
}) {
  const isOverflowSelected = overflowMetrics.includes(metric)
  const value = (item: Metric) => {
    if (item === 'summary_speaker_chips_named') return chipValue
    return summary ? metricValue(summary, item, filters).value : 'Not measured'
  }
  return (
    <div className={styles.metricChoices} aria-label="Explore a metric">
      {primaryMetrics.map((item) => (
        <button
          key={item}
          type="button"
          aria-pressed={metric === item}
          aria-label={`Explore ${metricPhrase(item)}`}
          onClick={() => onSelect(item)}
          className={`${styles.metricChoice} ${metric === item ? styles.selectedMetric : ''}`}
        >
          <span>{metricLabels[item]}</span>
          {item === 'summary_speaker_chips_named' && <small>{chipSourceLabel}</small>}
          <strong>{value(item)}</strong>
        </button>
      ))}
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <button
            type="button"
            aria-label="More metrics"
            className={`${styles.metricChoice} ${styles.metricOverflow} ${isOverflowSelected ? styles.selectedMetric : ''}`}
          >
            <MoreHorizontal size={22} aria-hidden="true" />
            {isOverflowSelected && <span>{metricLabels[metric]}</span>}
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <DropdownMenu.Content className={styles.splitMenu} align="end" sideOffset={6}>
            <DropdownMenu.RadioGroup value={metric} onValueChange={(next) => onSelect(next as Metric)}>
              {overflowMetrics.map((item) => (
                <DropdownMenu.RadioItem key={item} value={item} className={styles.menuItem}>
                  <DropdownMenu.ItemIndicator>
                    <Check size={14} />
                  </DropdownMenu.ItemIndicator>
                  <span>{metricLabels[item]}</span>
                  <strong>{value(item)}</strong>
                </DropdownMenu.RadioItem>
              ))}
            </DropdownMenu.RadioGroup>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  )
}
